import React, { useState } from "react";
import axios from "axios";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MainModal } from "../../../components/modal/MainModal";
import Table from "../../../components/coreUiTable/Table";
import { queryParams } from "../../../utils/queryParams";
import useUploadXlsx from "../../../hooks/useUploadXlsx";

export const UploadGoals = () => {
  const { error, file, onFileUpload, request, reset } = useUploadXlsx((params) =>
    axios.post(queryParams.apiVersion + "goals/upload", params)
  );

  const [isOpen, setOpen] = useState(false);

  const upload = () => {
    request();
    onClose();
  };

  const onClose = () => {
    setOpen(false);
    reset();
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={onClose}
        parentSelector=".goals-module"
        primaryButtonText="Upload"
        primaryBtnHandler={upload}
        primaryButtonClass="primary"
        primaryButtonDisabled={!file}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={onClose}
        secondaryBtnClass="secondary"
        width={650}
        height="auto"
        headerCloseHandler={onClose}
        headerText="Upload Goals"
        isAdminPanel={false}
      >
        <div className="goals-upload">
          <div className="goals-upload__info">
            Your <b>XLSX</b> should be in the following format:
          </div>

          <Table
            tableFilter={false}
            table={{
              colHeaders: ["Store ID", "Location", "Group", "Metic", "Goal", "Active"],
              data: [
                ["1111", "Location", "Group", "New Clients", "200", "true"],
                ["1111", "Location", "Group", "New Clients", "200", "true"],
                ["1111", "Location", "Group", "New Clients", "200", "false"]
              ]
            }}
          />
        </div>

        <input type="file" accept=".xlsx" placeholder="Choose XLSX file" onChange={onFileUpload} />

        {error && <div className="goals-upload__error">* {error}</div>}
      </MainModal>
      <FontAwesomeIcon
        title="Upload Goals"
        onClick={() => setOpen(true)}
        style={{
          color: "#8fc447",
          verticalAlign: "bottom",
          marginLeft: "8px",
          cursor: "pointer"
        }}
        width={15}
        height={15}
        icon={faUpload}
      />
    </>
  );
};
